import * as React from 'react';
import {Card, Grid} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from "@mui/material/IconButton";
import {MoreVertOutlined, CurrencyBitcoinOutlined} from '@mui/icons-material';
import {PiePlot, ChartContainer} from "@mui/x-charts";
import {XYVO} from "@/service/analyze";
import {sumBy} from "lodash";
import {useMemo} from "react";
import {ChartsLoadingOverlay} from "@mui/x-charts/ChartsOverlay";


export interface TrademarkCardProps {
    trademarks?: XYVO[]
    loading: boolean
}

export default function TrademarkCard({trademarks, loading}: TrademarkCardProps) {

    const {currTotalTrademark} = useMemo(() => {
        const currTotalTrademark = sumBy(trademarks, item => item.y) || 0
        return {currTotalTrademark}
    }, [trademarks]);

    return (
        <Card variant="outlined" sx={{height: '100%', flexGrow: 1, backgroundColor: '#d2f9f4'}}>
            <CardContent sx={{height: '100%'}}>
                <Stack justifyContent={'space-between'} height={'inherit'}>
                    <Stack justifyContent={'space-between'} direction={'row'} alignContent={'center'} alignItems={'center'}>
                        <Stack direction="row" spacing={1} alignContent={'center'} alignItems={'center'}>
                            <IconButton sx={{bgcolor: '#00ceb6', padding: '4px 12px', borderRadius: '99999px'}}>
                                <CurrencyBitcoinOutlined sx={{color: '#fff'}}/>
                            </IconButton>
                            <Typography fontWeight={500} component="h1" color={'#7b8893'} variant='body1'>
                                商标
                            </Typography>
                        </Stack>
                        <MoreVertOutlined color={'action'}/>
                    </Stack>
                    <Grid container rowSpacing={6} alignItems={'end'}>
                        <Grid size={6}>
                            <Chip label={<Typography fontSize={'12px'} color={'textSecondary'}>全部</Typography>}/>
                            <Typography component={'h1'} variant={'subtitle1'} fontSize={20} fontWeight={550}>{currTotalTrademark}个</Typography>
                        </Grid>
                        <Grid size={6}>
                            <ChartContainer
                                height={120}
                                localeText={{loading: loading ? "加载中" : ""}}
                                margin={{left: 0, right: 24, top: 0, bottom: -20}}
                                series={[{
                                    data: [{id: 'a', value: currTotalTrademark, color: '#b2efe8'}, {id: 'b', value: currTotalTrademark, color: '#00ceb6'}],
                                    type: 'pie',
                                    innerRadius: 32,
                                    outerRadius: 42
                                },
                                ]}
                            >
                                <ChartsLoadingOverlay/>
                                <PiePlot/>
                            </ChartContainer>
                        </Grid>
                    </Grid>
                </Stack>
            </CardContent>
        </Card>
    );
}
